import React from "react";
import "./Nav.css";
import NavLogin from "./NavLogin";

/**
 * Nav component of the application
 *
 * @returns {*}
 */
export default class Nav extends React.Component {
  state = {
    isOpen: false
  };

  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mouseup", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.handleOutsideClick);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleOutsideClick(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        isOpen: false
      });
    }
  }

  toggleNav() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  getNavListClassName() {
    if (this.state.isOpen) {
      return "Nav__List Nav__List__Open";
    }

    return "Nav__List";
  }

  render() {
    return (
      <div className="Nav" ref={this.setWrapperRef}>
        <ul className={this.getNavListClassName()}>
          {this.props.links.map((link, key) => (
            <li
              className="Nav__List__Item"
              onClick={this.toggleNav.bind(this)}
              key={key}
            >
              {link}
            </li>
          ))}

          <li className="Nav__List__Item">
            <NavLogin />
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/Sidebar/Nav.js